<template>
  <div class="contentBox">
    <div class="container">
      <div class="article auto-height">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <p class="strong">Đăng nhập tài khoản nền tảng đã liên kết với game</p>
        <div class="text">
          Người chơi thân mến, để đảm bảo an toàn cho tài khoản của bạn, vui
          lòng đăng nhập vào bất kỳ tài khoản nền tảng nào đã liên kết với tài
          khoản game mà bạn muốn hủy.
        </div>
        <div class="input-outer">
          <div class="input-wrap">
            <el-radio-group v-model="login_type" @change="handleTypeChange">
              <el-radio label="1" value="1">Email</el-radio>
              <el-radio label="2" value="2">Phone</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="input-outer">
          <div class="input-wrap">
            <div class="form-bg">
              <el-input
                v-model="username"
                :placeholder="login_type === '1' ? 'Email' : 'phone'"
              >
                <template slot="prepend" v-if="login_type == '2'"
                  >84 -
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="input-outer">
          <div class="input-wrap">
            <div class="form-bg">
              <el-input
                v-model="password"
                :placeholder="$t('Login.passwordPlaceholder')"
                show-password
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 使用 :class 动态绑定 active 类 -->
        <div
          class="btn mt auto-footer unactive"
          :class="{ active: isFormValid }"
          @click="handleClick()"
        >
          Login
        </div>
      </div>
    </div>
    <div data-v-0186101b="" class="mt-logo"></div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      username: "",
      password: "",
      login_type: "1",
    };
  },
  computed: {
    // 计算属性：判断表单是否有效
    isFormValid() {
      return this.username.trim() && this.password.trim();
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      let params = {
        username: this.username,
        password: this.password,
        login_type: this.login_type,
      };
      this.$http.post("/api/login", params).then((res) => {
        if (res.code === 200) {
          this.handleCheck(res.data.token);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleTypeChange(e) {
      console.log(e);
      this.username = "";
      this.password = "";
    },
    handleCheck(token) {
      this.$router.push({
        path: "/main/deletion/isDeleteAccount",
        query: {
          t: token,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/index.css";
</style>
